import { createAsyncThunk } from "@reduxjs/toolkit";
import { getGridResourceDataThunk } from "@/store/resources-grid/thunks/data/getGridResourceDataThunk";
import { gridResourceDataPayloadSelector } from "@/store/resources-grid/selectors/grid/gridResourceDataPayloadSelector";
import { RootState } from "@/store/store";
import { masterGridResourceTypeSelector } from "@/store/resources-grid/selectors/grid/masterGridResourceTypeSelector";
import { liveUsageMgmtRegionsSelector } from "@/store/live-usage-mgmt/selectors/store-selectors/liveUsageMgmtRegionsSelector";
import { addRegionsToFilters } from "@/utils/helpers/addRegionsToFilters";

export const updateGridResourceDataThunk = createAsyncThunk(
  "resourcesGrid/updateGridResourceDataThunk",
  async (masterGridId: string, { dispatch, getState }) => {
    const state = getState() as RootState;
    const payload = gridResourceDataPayloadSelector(state, masterGridId);
    const resourceType = masterGridResourceTypeSelector(state, masterGridId);
    const regions = liveUsageMgmtRegionsSelector(state);

    if (!payload || !resourceType) {
      return;
    }

    const emptyFilters = {
      type: resourceType,
      filter_items: [],
      filter_groups: [],
      operators: [],
    };

    const filters = payload.resourceFilters ?? emptyFilters;
    const resourceFilters = payload.regions?.length
      ? addRegionsToFilters(regions, filters)
      : filters;

    return await dispatch(
      getGridResourceDataThunk({
        resourceType,
        masterGridId,
        resourceFilters,
        account_ids: payload.accountIds,
      }),
    ).unwrap();
  },
);
